import { types, isType } from "mobx-state-tree"
import { getActiveEvents } from "../contract/Events"
import { getAllEvents, getSingleEvent } from "../api-calls/events"
import { Event } from '../models/Event';
import  CategoriesStore  from '../stores/CategoriesStore'

const Team = types.model({
    name: types.string
})

let defaultEvent = {
    _id: "types.identifier",
    bytes32Id: "0xsampleid",
    teams: ["team1", "team2"],
    drawPossible: false,
    maker: "types.string",
    makerBond: 0,
    categoryId: "types.string",
    leagueId: "types.string",
    cancelled: false,
    //locked: types.boolean,
    startTime: 0,
    duration: 0,
    finalized: undefined,
    betsForTeam: [0,0],
    betsForDraw: 0,
    amountBetForTeam: [0,0],
    amountBetForDraw: 0,
    isPropEvent: false,

    //endTime: types.number,
};

const EventStoreModel = types
    .model('EventStore', {
      
        loading: types.boolean,
        activeEvent: types.optional(Event, defaultEvent),
        loaded: types.boolean,
        events: types.map(Event),
    })
    .views(self => {
        return {
            isLoaded: () => self.loaded,
            isLoading: () => self.loading,
            getEvents: () => self.events.values(),
            getActiveEvent: () => self.activeEvent,
            getEventCount: () => self.events.size,
            getEventById: (eventId) => self.events.get(eventId),
        }
    })
    .actions(self => {
        return {
            queryEvents: async () => {
                self.loading = true;
                self.loaded = false;
                getAllEvents().then((events) => {
                    self.setEvents(events);
                    self.setLoading(false);
                    self.setLoaded(true);
                });
            },
            // queryEvents: async () => {
            //     self.loading = true;
            //     self.loaded = false;
            //     getAllEvents().then((events) => {
            //         self.setEvents(events);
            //         self.setLoading(false);
            //         self.setLoaded(true);
            //     });
            // },
            setEvents: (events) => {
                for (let event of events) {

                    self.events.put(event);
                }
            },
            querySingleEvent: async (eventId) => {
                return getSingleEvent(eventId).then((event) => {
                    self.setActiveEvent(event);
                });
            },
            // updateBackgroundImage: async (image) => {

            //     self.setImage(CategoriesStore.categories.get(self.activeEvent.categoryId));


            // },
            setImage: async (image) => {
                self.image = image;
            },
            setActiveEvent: (event) => {
                self.activeEvent = event;
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            }
        }
    });

const EventStore = EventStoreModel.create({
    loaded: false,
    loading: false,
    events: {},  
    activeEvent: {
        _id: "types.identifier",
        bytes32Id: "oxsampleid",
        teams: ["team1", "team2"],
        drawPossible: false,
        maker: "types.string",
        makerBond: 0,
        categoryId: "types.string",
        leagueId: "types.string",
        cancelled: false,
        //locked: types.boolean,
        startTime: 0,
        duration: 0,
        finalized: undefined,
        betsForTeam: [0,0],
        betsForDraw: 0,
        amountBetForTeam: [0,0],
        amountBetForDraw: 0,
        isPropEvent: false,
     
        //endTime: types.number,
    }
});

export default EventStore;


// WEBPACK FOOTER //
// ./src/stores/EventStore.js